import { SafeResourceUrl } from "@angular/platform-browser";

export interface FileForViewer {
    fileType: string;
    url: string | SafeResourceUrl;
    downloadUrl: string | SafeResourceUrl;
    blob: Blob
}
